// @ts-nocheck
import React, { FC } from 'react';

import { Container, Row, Col } from 'crehana-ui/GridV2';

import MembershipCard from './MembershipCard';
import { MembershipSection } from '../../types';

interface MembershipPlansProps extends MembershipSection {
  banner: {
    message: string;
    alternativeShortMessage: string;
    expirationDate: Date;
  } | null;
}

const MembershipPlans: FC<MembershipPlansProps> = ({
  title,
  memberships,
  membershipCardColors,
  banner,
}) => {
  return (
    <section id="membershipv2-plans" className="bg-base-dark py-40 md:py-64">
      <Container>
        <Row className="flex flex-col items-center" nowrap>
          <Col xs={12} sm={10}>
            <p className="font-h1 text-center mb-40 md:mb-64 text-white">
              {title}
            </p>
          </Col>
        </Row>
        <Row className={memberships.length < 3 ? 'lg:justify-center' : ''}>
          {memberships.map((membership, index, arr) => (
            <Col
              key={membership.originalId}
              xs={12}
              sm={6}
              md={4}
              lg={4}
              offset={{ xs: 0, sm: 3, md: 0, lg: 0 }}
              className={`${
                membership.isHighlighted ? 'order-1' : 'order-2'
              } md:order-1`}
            >
              <MembershipCard
                colors={membershipCardColors}
                membership={membership}
                isDarkTheme
                promo={banner}
                isFirstItem={index === 0}
                isLastItem={arr.length - 1 === index}
                showRegularPrice={membership.isHighlighted}
              />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default MembershipPlans;
